<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
    >
        <BoxLocalAtendimento :data="{form: form.infraestrutura, model: model.infraestrutura}" />
        <BoxAgendamento :data="{model: model.agendamento}" />
        <BoxAtendimento :data="{model: model.atendimento}" />
    </rkm-form>
</template>

<script>
// Components.
import BoxAgendamento from './components/agendamento/Form'
import BoxAtendimento from './components/atendimento/Form'
import BoxLocalAtendimento from './components/local-atendimento/Index'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        BoxAgendamento,
        BoxAtendimento,
        BoxLocalAtendimento,
    },
    created() {
        this.repositories = {
            parametrizacao: this.getConectaSusRepository('ambulatorio.parametrizacao'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
             this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        infraestrutura: {
                            infraestruturas: this.model.infraestrutura.infraestruturas.map(infraestrutura => {
                                const ocupacoes = infraestrutura.ocupacoes
                                const especialidades = infraestrutura.especialidades
                                const infraestruturasAgendadoras = infraestrutura.infraestruturasAgendadoras
                                const servicos = infraestrutura.servicos
                                const sms = infraestrutura.sms

                                return {
                                    id: infraestrutura.id,
                                    enviaSms: infraestrutura.enviaSms,
                                    faturaProcedimentoRaas: infraestrutura.faturaProcedimentoRaas,
                                    ocupacoes: ocupacoes.map(ocupacao => {
                                        return {
                                            id: ocupacao.id,
                                            atencaoBasicaFuncionalidades: ocupacao.atencaoBasicaFuncionalidades,
                                        }
                                    }),
                                    especialidades: especialidades.map(especialidade => {
                                        return {
                                            id: especialidade.id,
                                            avisaFaltaQuantidade: especialidade.avisaFaltaQuantidade,
                                            avisaFaltaDias: especialidade.avisaFaltaDias,
                                            quantidadeDiasRetorno: especialidade.quantidadeDiasRetorno,
                                        }
                                    }),
                                    infraestruturasAgendadoras: infraestruturasAgendadoras.map(infraestruturaAgendadora => {
                                        return {
                                            id: infraestruturaAgendadora.id,
                                        }
                                    }),
                                    servicos: servicos.map(servico => servico.id),
                                    sms: {
                                        diaAntecedencia: sms.diaAntecedencia,
                                        envioDe: sms.periodoEnvio.start,
                                        envioAte: sms.periodoEnvio.end,
                                        especialidades: sms.especialidades.map(especialidade => especialidade.id),
                                    },
                                    deleted: infraestrutura.deleted,
                                }
                            }),
                        },
                        agendamento: this.model.agendamento,
                        atendimento: this.model.atendimento,
                    }

                    this.repositories.parametrizacao.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then(() => {
                            this.$emit('saved')
                            this.showSaveNotification()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
}
</script>